import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
class ShiftbookInfoStateTab extends GenericListSearchTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
    }
    SaveAllowed: KnockoutObservable<boolean>;
    SearchType() { return "Shiftbook"; }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
}
export default ShiftbookInfoStateTab;